import React from 'react'
import { connect } from 'react-redux'
import { getUsaCaPrTermsAndConditionsByLang } from '../../helpers'
import { getSalesOrg } from '../../store/centers/reducers'
import { getLanguage } from '../../store/ui/reducers'
import Translation from '../global/Translation'

const mapStateToProps = state => {
    return {
        language: getLanguage(state),
        salesOrg: getSalesOrg(state)
    }
}

const TermsConditions = props => {
    const { onAcceptedChange, language, salesOrg, accepted } = props
    const usaSalesOrgs = ['2011', '2032', '2037']

    const toggleAcceptance = () => {
            onAcceptedChange(!accepted)
    }

    const getTermsUrl = () => {
        if (usaSalesOrgs.includes(salesOrg)) {
            return getUsaCaPrTermsAndConditionsByLang(language)
        }

        return 'https://assetstools.cosentino.com/api/v1/bynder/doc/511A2D40-054A-41D5-89CE81CF6DB105D8/cgv.pdf'
    }

    return (
        <div className="terms-conditions-container" onClick={toggleAcceptance}>
            <input
                type="checkbox"
                checked={accepted}
                onChange={e => {
                    e.stopPropagation()
                    toggleAcceptance()
                }}
            />

            <span>
                <Translation
                    id="terms_and_conditions_introduction_text"
                    defaultMessage="I understand and accept that when purchasing a custom-made product, I will not be able to cancel the order once Cosentino has begun manufacturing it, in accordance with the"
                />{' '}
                <a href={getTermsUrl()} target="_blank" rel="nofollow noopener noreferrer" onClick={e => e.stopPropagation()}>
                    <Translation id="general_terms_and_conditions_of_sale" defaultMessage="general terms and conditions of sale" />
                </a>
                .
            </span>
        </div>
    )
}

export default connect(mapStateToProps, null)(TermsConditions)
